exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".slds-global-header h1 {\n\tdisplay: none;\n}\n\n.slds-global-header__logo {\n\tbackground-image: url(/assets/images/C360_logo.svg);\n\theight: 1rem;\n\tmargin-left: 1.4rem;\n\t/*width: 12.5rem;*/\n}\n\n.df18Brunello .slds-global-header__logo {\n\theight: 2rem;\n\t/*background-image: url(/assets/images/shiseido-logo-black.png);*/\n\t/*width: 115px;\n\tbackground-image: url(/assets/images/brunello-logo.png);*/\n\tmargin-left: 0.3rem;\n}\n\n.df18Brunello .slds-global-header h1 {\n\tcolor: #032e61;\n\tdisplay: block;\n\tfont-size: 1.1rem;\n\tfont-weight: 400;\n\t/*left: 120px;\n\tleft: 153px;*/\n    left: 155px;\t\n    position: absolute;\n\ttop: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Header/header.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/Header/header.css
// module chunks = 0